import { StoreRequestDto } from './StoreRequestDto';
import { StyleVarietySizeRequestDto } from './StyleVarieySizeRequestDto';
import { TransferRequestExcelDto } from './TransferRequestExcelDto';

export class TransferRequestDto {
    id:number;
    language: number;
    week: number;
    reference: string;
    year: number;
    startDate: Date;
    endDate: Date;
    organizationId: string;
    data: TransferRequestExcelDto[];
    StoresValidated: StoreRequestDto[];
    StyleSizesValidated: StyleVarietySizeRequestDto[];
    skipDuplicateCheck: boolean;
    skipMaxVersionCheck: boolean;
}
